if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.checkoutButton = this.querySelector('[data-primefit-checkout]');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (this.cart && !this.submitButton.hasAttribute('data-primefit-checkout')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    connectedCallback() {
      if (!this.checkoutButton) return;
      const syncAvailability = () => {
        this.checkoutButton.disabled = this.submitButton.disabled;
        const label = this.checkoutButton.querySelector('[data-order-label]');
        if (label) {
          label.textContent = this.submitButton.disabled
            ? this.submitButton.querySelector('span').textContent.trim()
            : 'ORDER NOW';
        }
      };
      this.buttonObserver = new MutationObserver(syncAvailability);
      this.buttonObserver.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      syncAvailability();
    }

    disconnectedCallback() {
      this.buttonObserver?.disconnect();
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const button = evt.submitter || this.submitButton;
      if (this.submitting || button.disabled || this.submitButton.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const checkout = button.hasAttribute('data-primefit-checkout');
      const spinner = button.querySelector('.loading__spinner');
      this.submitting = true;
      this.error = false;
      this.handleErrorMessage();
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      this.form.setAttribute('aria-busy', 'true');
      spinner?.classList.remove('hidden');
      const formData = new FormData(this.form);
      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (this.cart && !checkout) {
          formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        const result = await fetch(routes.cart_add_url, config);
        const response = await result.json();
        if (!result.ok || response.status) {
          this.error = true;
          const message = response.description || response.message || 'Could not add this item. Please try again.';
          this.handleErrorMessage(message);
          publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.errors || message, message });
          return;
        }
        if (checkout) {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
          return;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
        if (!this.cart) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => setTimeout(() => this.cart.renderContents(response)), { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      } catch (error) {
        console.error(error);
        this.handleErrorMessage('Could not prepare your order. Please try again.');
      } finally {
        this.submitting = false;
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        this.form.removeAttribute('aria-busy');
        spinner?.classList.add('hidden');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
